import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

const Theme = createGlobalStyle`
  :root {
    /* COLORS */
    --color-primary: #B78E2A;
    --color-secondary: #747067;
    --color-secondary2: #666;
    --color-white: #ffffff;

    --color-gray: #fafafa;
    --color-gray2: #f5f5f5;
    --color-gray3: #ebebeb;
    --color-gray4: #cecece;

    --color-warning: #F8DC93;
    --color-info: #cce5ff;
    --color-gold: #DBAF3D;
    --color-gold2: #C0A233;
    --color-gold3: #A68B2B;
    --color-gradient: linear-gradient(180deg, #B78E2A -6.25%, #9E740D 100%);
    --text-gradient-gold: linear-gradient(104.29deg, #B78E2A 7.33%, #D3A940 28.87%, #B78E2A 51.97%, #D3A940 56.13%, #B78E2A 69.77%);

    --page-gutter: 16px;
    @media screen and (min-width: 992px) {
      --page-gutter: 26px;
    }

    @media screen and (max-width: 575px) {}
    @media screen and (min-width: 576px and max-width: 767px) {}
    @media screen and (min-width: 768px and max-width: 991px) {}
    @media screen and (min-width: 992px and max-width: 1199px) {}
    @media screen and (min-width: 1200px and max-width: 1399px) {}
    @media screen and (min-width: 1400px) {}
  }

  body {
    &.ReactModal__Body--open {
      overflow: hidden;
    }
  }

  html{
    background: #f8f8f8 !important;
  }

  html, body {
    background-color: var(--color-white);
    color: var(--color-secondary2);
    font-size: 16px;
    position: relative;
    -webkit-font-smoothing: antialiased;
    min-height: 100vh;
  }

  * {
    font-family: Montserrat, Helvetica, 'Droid Sans', Ubuntu, Arial, sans-serif;
    box-sizing: border-box;
  }

  a, button {
    cursor: pointer;
  }

  a,
  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
    color: var(--color-secondary2);
  }

  main {
    background: #F8F8F8;
    padding: var(--page-gutter);
    min-height: calc(100vh - 380px);
  }

  #root .desktop-only {
    display: none;
    visibility: hidden;
    opacity: 0;

    @media screen and (min-width: 996px) {
      display: initial;
      visibility: initial;
      opacity: initial;
    }
  }

  .mobile-only {
    display: initial;
    visibility: initial;
    opacity: initial;

    @media screen and (min-width: 996px) {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
  }

  span.badge {
    background: #996d01;
    border: 2px solid #ffffff;
    box-sizing: border-box;
    border-radius: 10px 10px 10px 0px;
    width: 24px;
    height: 24px;
    display: inline-block;
    font-size: 14px;
    line-height: 21px;
    color: #ffffff;
    position: absolute;
    text-align: center;
    right: -6px;
    font-weight: 500;
  }

  .slick-slider {
    .slick-track {
      margin-bottom: 3.75rem !important;
    }
  }

  .slick-dots li {
    &.slick-active button:before {
      color: var(--color-primary) !important;
    }
    button:before {
      font-size: 0.625rem;
      opacity: 1;
      color: #d5d5d5;
    }
  }
  .slick-arrow {
    &:before {
      content: initial;
      visibility: hidden;
      display: none;
    }
  }

  .parallax-outer {
    position: absolute;
  }

  @keyframes bannermove {
    0% { transform: translateX(0px); }
    100% { transform: translateX(-405px); }
  }

  @keyframes focus {
    0% {
      transform: scale(1);
    }
    20% {
      transform: scale(1.5);
    }
    90% {
      transform: scale(1.15);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes swing {
    25% {
      transform: rotate(-5deg);
    }
    50% {
      transform: rotate(0deg);
    }
    75% {
      transform: rotate(5deg);
    }
  }

  .hidden {
    &-xs {
      @media screen and (max-width: 575px) {
        display: none; visibility: hidden;
      }
    }
    &-sm {
      @media screen and (min-width: 576px) and (max-width: 767px) {
        display: none; visibility: hidden;
      }
    }
    &-md {
      @media screen and (min-width: 768px) and (max-width: 991px) {
        display: none; visibility: hidden;
      }
    }
    &-lg {
      @media screen and (min-width: 768px) and (max-width: 991px) {
        display: none; visibility: hidden;
      }
    }
  }

  select {
    background: white;
    color: #666;
    border: 1px solid #666;
  }


  @media print {
    header {
      display: none;
    }

    input {
      border: 0 !important;
    }
  }

`;

export default Theme;
